import { IInteractionRpc } from "@pulse-ui/codegen/generated_ts/managed_algo";
import { type DefaultSlot } from "./defaultRpcs";

export const STOPPED = "stopped";
export const STOPPING = "stopping";
export const RUNNING = "running";
export const STARTING = "starting";

// Disable logic is driven purely by the default slot and row status.
export function isRpcDisabledForStatus(
  slot: DefaultSlot | undefined,
  status: string | undefined
): boolean {
  if (!status || !slot) return false;
  const normalized = status.trim().toLowerCase();

  if (normalized === STOPPED || normalized === STOPPING) {
    return slot === "stop" || slot === "pause";
  }
  if (normalized === RUNNING || normalized === STARTING) {
    return slot === "resume";
  }
  return false;
}

export type InteractionDataByConnection = Record<string, IInteractionRpc>;
